import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { DEFAULT_LOCALE, LOCALES } from '../components/i18n'

export const useLanguage = () => {
  const { i18n } = useTranslation()

  const resolved = i18n.resolvedLanguage || i18n.language
  const language = LOCALES.includes(resolved) ? resolved : DEFAULT_LOCALE

  const setLanguage = useCallback(
    (next) => {
      if (LOCALES.includes(next) && next !== language) {
        i18n.changeLanguage(next)
      }
    },
    [i18n, language]
  )

  const toggleLanguage = useCallback(
    () => setLanguage(language === 'en' ? 'fr' : 'en'),
    [language, setLanguage]
  )

  return { language, setLanguage, toggleLanguage }
}
